import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import apiClient from './apiClient';

const withRequestDemo = () => {
  const Context = React.createContext({});

  const RequestDemoProvider = ({ children }) => {
    const [popupDemo, setPopupDemo] = useState(false);

    const [demoSuccess, setDemoSuccess] = useState('');

    const [demoError, setDemoError] = useState('');

    useEffect(() => {
      document.body.classList.toggle('modal-open', popupDemo);
    }, [popupDemo]);

    const popupDemoClick = useCallback((e) => {
      if (e.type === 'click') setPopupDemo((state) => !state);
    }, []);

    const onSubmit = useCallback((input, callback) => {
      (async () => {
        try {
          await apiClient.post('/request-demo', {
            data: JSON.stringify({ contact: input }),
          });

          setDemoSuccess('Your demo request is submitted successfully.');

          callback();
        } catch (error) {
          /* do nothing */
          setDemoError('Something went wrong, try again.');
        } finally {
          setPopupDemo(false);
        }
      })();
    }, []);

    const clickHandler = useCallback(
      (e) => {
        if (
          popupDemo === true &&
          e.target.classList.contains('download-app-popup')
        )
          setPopupDemo(false);
      },
      [popupDemo],
    );

    const keyDownHandler = useCallback(
      (e) => {
        if (popupDemo === true && e.key === 'Escape') setPopupDemo(false);
      },
      [popupDemo],
    );

    useEffect(() => {
      window.addEventListener('click', clickHandler);
      window.addEventListener('keydown', keyDownHandler);

      return () => {
        window.removeEventListener('click', clickHandler);
        window.removeEventListener('keydown', keyDownHandler);
      };
    }, [clickHandler, keyDownHandler]);

    useEffect(() => {
      if (demoSuccess) {
        const timeout = setTimeout(() => {
          setDemoSuccess('');
          setPopupDemo(false);
        }, 5000);

        return () => {
          clearTimeout(timeout);
        };
      }

      return () => {
        /* do nothing */
      };
    }, [demoSuccess]);

    useEffect(() => {
      if (demoError) {
        const timeout = setTimeout(() => {
          setDemoError('');
        }, 5000);

        return () => {
          clearTimeout(timeout);
        };
      }

      return () => {
        /* do nothing */
      };
    }, [demoError]);

    return (
      <Context.Provider
        value={{
          popupDemo,
          demoSuccess,
          demoError,
          popupDemoClick,
          popupDemoSubmit: onSubmit,
        }}>
        {children}
      </Context.Provider>
    );
  };

  RequestDemoProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };

  const useRequestDemo = () => React.useContext(Context);

  return {
    RequestDemoProvider,
    useRequestDemo,
  };
};

export const { RequestDemoProvider, useRequestDemo } = withRequestDemo();
